import React from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '~/redux/root-reducer';
import {THYROID_FUNCTION_TEST_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/thyroid-function-test/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/thyroid-function-test/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/thyroid-function-test/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/thyroid-function-test/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/thyroid-function-test/Questionnaire5Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const ThyroidFunctionTest = () => {
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case THYROID_FUNCTION_TEST_KEYS.START:
        trackPageViewGA('/thyroid-function-test/start', 'MDQ-Thyroid Function Test - Start');
        return <Questionnaire1Screen />;
      case THYROID_FUNCTION_TEST_KEYS.PROFILE:
        trackPageViewGA('/thyroid-function-test/profile', 'MDQ-Thyroid Function Test - Profile');
        return <Questionnaire2Screen />;
      case THYROID_FUNCTION_TEST_KEYS.INVALID:
        trackPageViewGA('/thyroid-function-test/invalid', 'MDQ-Thyroid Function Test - Invalid');
        return <Questionnaire3Screen />;
      case THYROID_FUNCTION_TEST_KEYS.APPOINTMENT_PREFERENCES:
        trackPageViewGA(
          '/thyroid-function-test/appointment-preferences',
          'MDQ-Thyroid Function Test - Appointment Preferences',
        );
        return <Questionnaire4Screen />;
      case THYROID_FUNCTION_TEST_KEYS.YOUR_TEST_PACKAGE:
        trackPageViewGA('/thyroid-function-test/your-test-package', 'MDQ-Thyroid Function Test - Your Test Package');
        return <Questionnaire5Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <Questionnaire1Screen />;
    }
  };

  return renderQuestion();
};

export default ThyroidFunctionTest;
